import ProductsArchive from './ProductsArchive/ProductsArchive'

/* Don't touche under this line for security reasons */
document.addEventListener("DOMContentLoaded", function() {

    ProductsArchive.init()

})
